import { Button } from "@/components/ui/button";
import { CardTitle } from "@/components/ui/card";
import { HasAccess } from "@/components/common/has-access";
import { Pencil } from "lucide-react";

interface UserProfileHeaderProps {
  fullName: string;
  onEditClick: () => void;
}

export function UserProfileHeader({ fullName, onEditClick }: UserProfileHeaderProps) {
  return (
    <div className="flex items-center gap-3">
      <CardTitle className="text-2xl">
        {fullName || "User Name"}
      </CardTitle>
      <HasAccess permission="write">
        <Button
          variant="outline"
          size="sm"
          className="bg-transparent"
          onClick={onEditClick}
        >
          <Pencil size={4}/>
          Edit Profile
        </Button>
      </HasAccess>
    </div>
  );
}

